import { useEffect, useState } from 'react';
import Footer from '../../components/Footer/Footer';
import Menu from '../../components/Menu/Menu';
import Pager from '../../components/Pager/Pager';
import Toast from '../../components/Toast/Toast';
import {
    getFeedback,
    updateFeedbackStatus,
} from '../../services/FeedbackService';
import FeedbackModal from './FeedbackModal';
import FeedbackRow from './FeedbackRow';

const PAGE_SIZE = 10;

function Feedback() {
    const [messages, setMessages] = useState([]);
    const [count, setCount] = useState(0);
    const [page, setPage] = useState(1);
    const [status, setStatus] = useState('');
    const [type, setType] = useState('');
    const [view, setView] = useState(null);

    const [notification, setNotification] = useState({ type: '', text: '' });

    function onError(err) {
        console.error(err.response ? err.response.data : err.message);
        setNotification({
            type: 'error',
            text: err.response ? err.response.data : err.message,
        });
    }

    function loadFeedback() {
        getFeedback({ status, type, page })
            .then(result => {
                setMessages(result.rows);
                setCount(result.count);
            })
            .catch(onError);
    }

    useEffect(() => {
        loadFeedback();
    }, [status, type, page]);

    function onFilterChange(event) {
        const { id, value } = event.target;
        setPage(1);
        if (id === 'status') setStatus(value);
        else setType(value);
    }

    function onViewClick(event) {
        const id = event.currentTarget.id.replace('view', '');
        setView(messages.find(m => String(m.id) === id) || null);
    }

    function onStatusChange(id, nextStatus) {
        updateFeedbackStatus(id, nextStatus)
            .then(updated => {
                setNotification({
                    type: 'success',
                    text: 'Status updated.',
                });
                setView(current =>
                    current && String(current.id) === String(id)
                        ? updated
                        : current,
                );
                loadFeedback();
            })
            .catch(onError);
    }

    return (
        <>
            <Menu />
            <main className="content">
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                    <div className="d-block mb-4 mb-md-0">
                        <h2 className="h4">Feedback</h2>
                    </div>
                    <div className="btn-toolbar mb-2 mb-md-0">
                        <select
                            id="type"
                            className="form-select me-2"
                            value={type}
                            onChange={onFilterChange}
                        >
                            <option value="">All types</option>
                            <option value="feedback">Feedback</option>
                            <option value="bug">Bug report</option>
                            <option value="doubt">Doubt</option>
                        </select>
                        <select
                            id="status"
                            className="form-select"
                            value={status}
                            onChange={onFilterChange}
                        >
                            <option value="">All statuses</option>
                            <option value="new">New</option>
                            <option value="read">Read</option>
                            <option value="resolved">Resolved</option>
                            <option value="archived">Archived</option>
                        </select>
                    </div>
                </div>
                <div className="card card-body border-0 shadow table-wrapper table-responsive">
                    <table className="table table-hover">
                        <thead>
                            <tr>
                                <th className="border-gray-200">Type</th>
                                <th className="border-gray-200">User</th>
                                <th className="border-gray-200">Message</th>
                                <th className="border-gray-200">Status</th>
                                <th className="border-gray-200">Received</th>
                                <th className="border-gray-200">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {messages && messages.length ? (
                                messages.map(message => (
                                    <FeedbackRow
                                        key={message.id}
                                        data={message}
                                        onViewClick={onViewClick}
                                    />
                                ))
                            ) : (
                                <></>
                            )}
                        </tbody>
                    </table>
                    <Pager
                        count={count}
                        page={page}
                        size={PAGE_SIZE}
                        onClick={setPage}
                    />
                </div>
                <Footer />
            </main>
            {view && (
                <FeedbackModal
                    data={view}
                    onClose={() => setView(null)}
                    onStatusChange={onStatusChange}
                />
            )}
            <Toast
                type={notification.type}
                text={notification.text}
                onShow={() => setNotification({})}
            />
        </>
    );
}

export default Feedback;
